import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    Typography,
  } from "@mui/material";
  import React from "react";

  import { useForm } from "react-hook-form";
import { WSIcons } from "../../../commonFunctions/iIcons";
import WSTextField from "../../../Components/TextBox/WSTextBox";
import WSTextAreaField from "../../../Components/WSTextArea/WSTextArea";
  
  export const CashOut: React.FC<any> = React.memo(
    ({ open, onClose }) => {
      const { control, register,handleSubmit } = useForm();
    
      const onSubmit = async (data: any) => {
          debugger;
          console.log("onsubmit===>", data); // You can perform any action with the submitted data here
        };
  
        
      return (
        <Dialog
          open={open}
          onClose={onClose}
          maxWidth='md'
          PaperProps={{
            style: {
              backgroundColor: "whitesmoke",
            },
          }}
        >
  <form onSubmit={handleSubmit(onSubmit)}>     
              <DialogTitle sx={{ backgroundColor: "green" }}>
            <Grid
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="h6" color={"white"}>
               Cash Out Entry
              </Typography>
              <IconButton onClick={onClose}>
                <WSIcons.CloseIcon sx={{ color: "white" }} />
              </IconButton>
            </Grid>
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2} sx={{ mt: 2 }}>
              <Grid item xs={12} sm={3}>
                <Typography>Amount</Typography>
              </Grid>
              <Grid item xs={12} sm={8}>
                <WSTextField
                  label={""}
                  {...register("amount")}
                  id="amount"
                  name="amount"
                  control={control}
                  rules={{ required: true }}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Typography>Remark</Typography>
              </Grid>
             <Grid item xs={12} sm={8}>
             <WSTextAreaField
                  label={""}
                  id={"remark"}
                  name={"remark"}
                  control={control}
                  rules={{ required: false }}
                  rows={2}
                />      
              </Grid>
             
             
            </Grid>
          </DialogContent>
          <Grid
            item
            sx={{
              backgroundColor: "#333",
              padding: "1rem",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Grid container spacing={2} alignItems="center" gap={3}>
              <Grid item>
                <WSIcons.GTranslateIcon sx={{ color: "white" }} />
              </Grid>
            </Grid>
  
            <Button
              variant="contained"
              sx={{
                width:"11rem",
                backgroundColor: "green",
                "&:hover": {
                  backgroundColor: "#388e3c",
                },
                
              }}
              onClick={handleSubmit(onSubmit)}
            >
              Save & Close
            </Button>
          </Grid>
          </form>
        </Dialog>
      );
    }
  );
  